<template>
  <div id="app">
    <v-app>
      <router-view/>
      <a-full-page-spinner></a-full-page-spinner>
      <a-image-uploader-modal></a-image-uploader-modal>
      <info-snack-bar></info-snack-bar>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AFullPageSpinner from '@/components/shared/AFullPageSpinner'
import AHeader from '@/components/shared/AHeader'
import InfoSnackBar from '@/components/shared/InfoSnackBar'
import AImageUploaderModal from '@/components/shared/AImageUploaderModal'
import Home from '@/components/pages/Home'
import { SignalR } from '../plugins/signalr-no-jquery'
import DeviceId from '../plugins/deviceId'
import {isNil} from 'ramda'

export default {
  name: 'App',
  components: {
    AFullPageSpinner,
    AHeader,
    InfoSnackBar,
    AImageUploaderModal,
    Home
  },
  data () {
    return {
      routeNames: ['awards-settings-step1', 'awards-settings-general', 'awards-settings-step2', 'cookies-alert', 'global-settings', 'google-pixel', 'Banner Display Settings'],
      events: ['mousemove', 'keydown'],
      eIntervalTime: 60000,
      eInterval: null,
      isOnline: false,
      isEvents: false,
      signalR: null,
      isReconnect: false
    }
  },
  watch: {
    userScopes() {
      this.isLoggedIn ? this.startConnection() : this.stopConnection()
    },
    getAccessToken(newVal, oldVal){
      if(newVal && oldVal && newVal !== oldVal) this.reconnect()
    },
    getIsConnected(val){
      if (val) this.isReconnect = false
    },
    getIsInvoke(val){
      if(!val) this.stopConnection()
    },
    getIsDisconnected(val){
      if (val && !this.isReconnect && this.isLoggedIn && this.getIsInvoke) this.reconnect()
    },
    isLoggedIn: {
      immediate: true,
      handler: async function watchLoggedIn (val) {
        try {
          if (val) {
            await this.fetchGeneralSettings()
            await this.fetchEmailTemplates()
            await this.fetchCurrentUserDetails()
          }
        } catch (err) {
          console.error(err)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'getAccessToken',
      'userScopes',
      'getIsSuperUser',
      'getIsConnected',
      'getIsDisconnected',
      'getIsInvoke'
    ])
  },
  methods: {
    ...mapActions([
      'fetchGeneralSettings',
      'fetchEmailTemplates',
      'fetchCurrentUserDetails'
    ]),
    startConnection() {
      if(this.getIsConnected || this.getIsSuperUser) return
      this.signalR = new SignalR(this.getAccessToken, DeviceId)
      this.signalR.connect()
      this.addEvents()
      this.setInt()
    },
    stopConnection() {
      this.removeEvents()
      this.clearInt()
      if(!isNil(this.signalR) && this.getIsConnected){
        this.signalR.stopConnection()
      }
    },
    reconnect(){
      this.isReconnect = true
      if(this.getIsConnected) this.stopConnection()
      this.startConnection()
    },
    addEvents(){
      if (this.isEvents) return
      this.events.forEach((event) => {
        document.addEventListener(event, this.isOnlineEvents)
      })
      this.isOnline = false
      this.isEvents = true
    },
    removeEvents(){
      if (!this.isEvents) return
      this.events.forEach((event) => {
        removeEventListener(event, this.isOnlineEvents)
      })
      this.isEvents = false
    },
    isOnlineEvents() {
      this.isOnline = true
      this.removeEvents()
    },
    setInt(){
      this.eInterval = setInterval(this.intervalHandler, this.eIntervalTime)
    },
    clearInt () {
      clearInterval(this.eInterval)
    },
    intervalHandler () {
      if (this.isOnline && this.isLoggedIn) {
        this.signalR.invokeActionOccured()
      }
      this.addEvents()
    }
  },
  beforeDestroy() {
    this.stopConnection()
  }
}
</script>

<style lang="scss">
// jodit styles should be above vuetify styles to avoid collisions in css
@import './../plugins/jodit/jodit.min.css';
@import 'vuetify/dist/vuetify.min.css';
@import './assets/scss/index.scss';

table.table .input-group--selection-controls.checkbox .icon {
  left: unset;
  transform: translateX(0);
}

</style>



// WEBPACK FOOTER //
// src/App.vue